module.exports = __webpack_public_path__ + "images/4006028abcc9148338ee59feb4c4187e-super-graph.png";